(() => {
  const configElement = document.getElementById('EsmerallyPurchaseReviewConfig');
  if (!configElement || !document.body.hasAttribute('data-esmerally-purchase-review')) return;
  const config = JSON.parse(configElement.textContent);
  const spanish = config.locale === 'es' || config.locale.startsWith('es-');
  const productSelector = '[data-product-handle="esmerally-womens-pack"]';
  const bundleSelector = '[data-product-handle="womens-pack-glow-easy-lip-oil-bundle"]';
  const textMap = new Map(Object.entries(config.translations));
  const normalize = (value) => value.replace(/\s+/g, ' ').trim();
  const individualHandles = new Set(['apple-cider-vinegar-gummies', 'womens-multi-boost-gummies', 'esmerally-glow-easy-lip-oil']);
  const individualProductCache = new WeakMap();
  const individualButtonLabels = new WeakMap();
  const syncIndividualCta = () => {
    if (!config.individualCta) return;
    document.querySelectorAll('form.product-single__form').forEach((form) => {
      const source = form.querySelector('.sealsubs-target-element[data-product]');
      const button = form.querySelector('[data-add-to-cart]');
      const text = button && button.querySelector('[data-add-to-cart-text]');
      if (!source || !button || !text || button.disabled || button.classList.contains('btn--loading')) return;
      let product = individualProductCache.get(source);
      if (!product) {
        try { product = JSON.parse(source.getAttribute('data-product')); } catch (_) { return; }
        individualProductCache.set(source, product);
      }
      if (!individualHandles.has(product.handle)) return;
      const original = text.getAttribute('data-default-text');
      const previous = individualButtonLabels.get(button);
      if (normalize(text.textContent) !== original && normalize(text.textContent) !== previous) return;
      const restore = () => {
        if (previous && normalize(text.textContent) === previous) text.textContent = original;
        individualButtonLabels.delete(button);
      };
      const variantId = form.elements.namedItem('id')?.value;
      const planId = form.elements.namedItem('selling_plan')?.value;
      const variant = product.variants.find((item) => String(item.id) === String(variantId));
      if (!variant || !variant.available) { restore(); return; }
      const active = form.querySelector('.sls-option-container.sls-active');
      if (!active || Boolean(planId) !== active.hasAttribute('data-selling-plan-group')) { restore(); return; }
      let price = variant.price;
      let template = config.individualCta.oneTime;
      if (planId) {
        const allocation = variant.selling_plan_allocations.find((item) => String(item.selling_plan_id) === String(planId));
        const plan = product.selling_plan_groups.flatMap((group) => group.selling_plans).find((item) => String(item.id) === String(planId));
        if (!allocation || !plan || active.querySelector('.sls-select')?.value !== String(planId)) { restore(); return; }
        price = allocation.price;
        const monthly = active.getAttribute('data-prepaid') !== 'true' && plan.options.some((option) => /^(?:1\s+)?(?:mes|month)$/i.test(option.value.split('·')[0].trim()));
        template = monthly ? config.individualCta.monthly : config.individualCta.subscription;
      }
      if (!Number.isFinite(price) || !template) { restore(); return; }
      const amount = new Intl.NumberFormat(config.locale === 'es' ? 'es-US' : config.locale, {
        style: 'currency', currency: config.currency, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(price / 100);
      const label = template.replace('{amount}', amount);
      if (text.textContent !== label) text.textContent = label;
      individualButtonLabels.set(button, label);
    });
  };
  const purchaseMode = (section) => {
    const active = section.querySelector('.sls-option-container.sls-active');
    if (!active) return 'unknown';
    if (active.getAttribute('data-prepaid') === 'true') return 'prepaid';
    return active.hasAttribute('data-selling-plan-group') ? 'monthly' : 'one-time';
  };
  const syncPaymentSummary = (section) => {
    const widget = section.querySelector('.sls-purchase-options-container');
    const active = widget && widget.querySelector('.sls-option-container.sls-active');
    const price = active && active.querySelector('.sls-price .money');
    const mode = purchaseMode(section);
    const select = active && active.querySelector('.sls-select');
    const planId = select && select.value;
    const periods = { '11831247083': 'monthly', '11836522731': 'monthly', '7813333227': 'monthly', '11837047019': 'monthly', '11836850411': 'monthly', '7813497067': 'six', '7813529835': 'twelve' };
    const period = mode === 'one-time' ? 'oneTime' : periods[planId];
    let summary = section.querySelector('.esmerally-payment-summary');
    if (!spanish || !price || !period || !config.paymentSummary) {
      if (summary) summary.remove();
      section.classList.remove('esmerally-has-payment-summary');
      return;
    }
    const amount = normalize(price.textContent) + ' ' + config.currency;
    const lines = [config.paymentSummary.today, config.paymentSummary[period]];
    if (section.matches(bundleSelector) && mode === 'monthly') lines.push(config.paymentSummary.bundle);
    lines.push(config.paymentSummary.scope);
    const text = lines.map(line => line.replace('{amount}', amount)).join('\n');
    if (!summary) {
      summary = document.createElement('p');
      summary.className = 'esmerally-payment-summary';
      summary.setAttribute('aria-live', 'polite');
      widget.insertAdjacentElement('afterend', summary);
    }
    if (summary.textContent !== text) summary.textContent = text;
    section.classList.add('esmerally-has-payment-summary');
  };
  // Keep the existing ingredient block reachable after jumping directly to purchase.
  const syncIngredientAccess = () => {
    if (!spanish) return;
    [
      { productId: '8017587863787', targetId: 'esmerally-aportes-duo', label: 'Ver las 10 vitaminas y sus beneficios' },
      { productId: '7878825640171', targetId: 'esmerally-aportes-acv', label: 'Ver los 7 componentes y sus funciones' }
    ].forEach(({ productId, targetId, label }) => {
      const buy = document.getElementById('esmerally-buy-' + productId);
      if (!buy || !document.getElementById(targetId) || buy.querySelector('[data-esmerally-ingredient-access]')) return;
      const link = document.createElement('a');
      link.className = 'esmerally-nutrient-jump';
      link.href = '#' + targetId;
      link.textContent = label;
      link.setAttribute('data-esmerally-ingredient-access', '');
      buy.insertAdjacentElement('afterbegin', link);
    });
  };
  const syncPricePresentation = () => {
    document.querySelectorAll('.product-section[data-esmerally-price-product]').forEach((section) => {
      const summary = section.querySelector('[data-esmerally-one-time-summary]');
      const individual = ['7939212411115', '7878825640171'].includes(section.getAttribute('data-esmerally-price-product'));
      if (!summary && !individual) return;
      const mode = purchaseMode(section);
      const oneTime = mode === 'one-time';
      section.classList.toggle('esmerally-price-one-time', oneTime);
      if (summary) summary.hidden = !oneTime;
      const unit = section.querySelector('[data-esmerally-monthly-unit]');
      if (unit) unit.hidden = mode !== 'monthly';
      const label = section.querySelector('.product-block--price > .variant__label');
      const labelText = mode === 'prepaid' ? config.prepaidTotal : mode === 'monthly' ? config.monthlyPriceLabel : individual && oneTime ? config.individualOneTimeLabel : config.price;
      if (label && label.textContent.trim() !== labelText) label.textContent = labelText;
      if (individual) {
        const widget = section.querySelector('.sls-purchase-options-container');
        let note = section.querySelector('.esmerally-individual-purchase-note');
        const noteText = mode === 'monthly' ? config.individualMonthlyNote : mode === 'prepaid' ? config.individualPrepaidNote : oneTime ? config.oneTimeNote : '';
        if (widget && noteText) {
          if (!note) {
            note = document.createElement('p');
            note.className = 'esmerally-individual-purchase-note';
            note.setAttribute('aria-live', 'polite');
            widget.insertAdjacentElement('afterend', note);
          }
          if (note.textContent !== noteText) note.textContent = noteText;
        } else if (note) note.remove();
      }
    });
  };
  const translate = (root) => {
    if (!root || !spanish) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (node.parentElement.closest('script, style, textarea, #judgeme_product_reviews, .jdgm-carousel-wrapper')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const changes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const current = normalize(node.nodeValue);
      const replacement = textMap.get(current);
      if (replacement && replacement !== current) changes.push([node, replacement]);
    }
    changes.forEach(([node, replacement]) => {
      const leading = node.nodeValue.match(/^\s*/)[0];
      const trailing = node.nodeValue.match(/\s*$/)[0];
      node.nodeValue = leading + replacement + trailing;
    });
    const ariaElements = Array.from(root.querySelectorAll('[aria-label]'));
    if (root.matches('[aria-label]')) ariaElements.unshift(root);
    ariaElements.forEach((element) => {
      const current = element.getAttribute('aria-label');
      const replacement = textMap.get(normalize(current));
      if (replacement && replacement !== current) element.setAttribute('aria-label', replacement);
    });
  };
  // Draft only: prefer verified monthly plans, retaining a deliberate choice per product.
  const monthlyPlans = {
    'esmerally-womens-pack': '11831247083',
    'womens-pack-glow-easy-lip-oil-bundle': '11836522731',
    'apple-cider-vinegar-gummies': '11837047019'
  };
  const initializedPurchaseSections = new WeakSet();
  const defaultPurchaseSelector = productSelector + ', ' + bundleSelector + ', .product-section[data-esmerally-price-product="7878825640171"]';
  const productKey = section => section.getAttribute('data-product-handle') || (section.getAttribute('data-esmerally-price-product') === '7878825640171' ? 'apple-cider-vinegar-gummies' : '');
  const storageKey = section => 'esmerally:purchase-choice:v1:' + productKey(section);
  const rememberedChoice = section => {
    try { return JSON.parse(sessionStorage.getItem(storageKey(section))); } catch (_) { return null; }
  };
  const rememberPurchase = event => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const widget = event.target.closest('.sls-purchase-options-container');
    const section = widget && widget.closest(defaultPurchaseSelector);
    if (!section || !event.target.closest('.sls-option-container')) return;
    initializedPurchaseSections.add(section);
    const chosen = event.target.closest('.sls-option-container');
    if (chosen.getAttribute('data-prepaid') === 'true') return;
    const select = chosen.querySelector('.sls-select');
    const choice = { mode: chosen.hasAttribute('data-selling-plan-group') ? 'monthly' : 'one-time', plan: select ? select.value : null };
    try { sessionStorage.setItem(storageKey(section), JSON.stringify(choice)); } catch (_) { /* A blocked store must not prevent buying. */ }
  };
  document.addEventListener('click', rememberPurchase, true);
  document.addEventListener('change', rememberPurchase, true);
  const initializePurchaseChoice = () => {
    document.querySelectorAll(defaultPurchaseSelector).forEach(section => {
      if (initializedPurchaseSections.has(section)) return;
      const widget = section.querySelector('.sls-purchase-options-container');
      const active = widget && widget.querySelector('.sls-option-container.sls-active');
      if (!active) return;
      const saved = rememberedChoice(section);
      const purchaseParameters = new URLSearchParams(window.location.search);
      const explicitPlan = purchaseParameters.get('selling_plan');
      const explicitMode = section.matches(bundleSelector) ? purchaseParameters.get('purchase_option') : null;
      if (!saved && explicitPlan && !explicitMode) { initializedPurchaseSections.add(section); return; }
      const oneTime = widget.querySelector('.sls-option-container:not([data-selling-plan-group])');
      const plan = monthlyPlans[productKey(section)];
      const planOption = plan && widget.querySelector('.sls-select option[value="' + plan + '"]');
      const monthly = planOption && planOption.closest('.sls-option-container');
      const target = explicitMode === 'one-time' ? oneTime : explicitMode === 'monthly' ? monthly : saved && saved.mode === 'one-time' ? oneTime : monthly;
      if (!target) return;
      const radio = target.querySelector('[role="radio"]');
      if (!radio) return;
      initializedPurchaseSections.add(section);
      if (target !== active) radio.click();
    });
  };
  // On Duo, translate only subtrees whose text was inserted or changed.
  // The initial pass and every other page retain the complete traversal.
  const incrementalTranslations = location.pathname.endsWith('/pages/womens-pack-vitamins');
  const pendingTranslations = new Set();
  let translatedInitially = false;
  const sync = () => {
    observer.disconnect();
    initializePurchaseChoice();
    document.querySelectorAll(productSelector).forEach(section => {
      section.toggleAttribute('data-esmerally-choice-initialized', initializedPurchaseSections.has(section));
    });
    // Hide draft storefront offers only; subscription plans and contracts remain intact.
    document.querySelectorAll('.sls-purchase-options-container').forEach((widget) => {
      const prepaid = widget.querySelector('.sls-option-container[data-prepaid="true"]');
      if (!prepaid) return;
      if (prepaid.classList.contains('sls-active')) {
        const oneTime = widget.querySelector('.sls-option-container:not([data-selling-plan-group]) [role="radio"]');
        if (oneTime) oneTime.click();
      }
      prepaid.querySelectorAll('input, select').forEach((control) => { control.disabled = true; });
    });
    document.querySelectorAll('#MainContent a[href^="/pages/esmerally-womens-packs"]').forEach((link) => {
      link.setAttribute('href', '/products/esmerally-womens-pack');
    });
    if (spanish) {
      const translationRoots = [document.getElementById('MainContent'), document.getElementById('SiteHeader'), document.getElementById('shopify-section-footer'),
       document.getElementById('seal-loyalty-main-button-text'),
       document.querySelector('[id$="__17332068787184144230"]')].filter(Boolean);
      if (!incrementalTranslations || !translatedInitially) {
        translationRoots.forEach(translate);
        translatedInitially = true;
      } else {
        const roots = Array.from(pendingTranslations).filter(root => root.isConnected && translationRoots.some(scope => scope.contains(root)));
        roots.filter(root => !roots.some(other => other !== root && other.contains(root))).forEach(translate);
      }
      pendingTranslations.clear();
      document.querySelectorAll('#MainContent [data-save-price]').forEach((savings) => {
        const amount = savings.textContent.match(/\$[\d,.]+/);
        if (amount && /\bsav(?:e|ing)\b/i.test(savings.textContent)) {
          savings.textContent = config.save + ' ' + amount[0];
        }
      });
      document.querySelectorAll('#MainContent .sls-select').forEach((select) => {
        const label = select.closest('[data-prepaid="true"]') ? config.intervalLabel : config.monthlyInterval;
        if (select.getAttribute('aria-label') !== label) select.setAttribute('aria-label', label);
      });
      document.querySelectorAll(bundleSelector).forEach((section) => {
        const active = section.querySelector('.sls-option-container.sls-active');
        const checkout = section.querySelector('a[id="more-payment-options-link"]');
        if (!active || !checkout) return;
        const recurring = active.hasAttribute('data-selling-plan-group');
        const label = recurring ? config.bundleSubscribeCta : config.bundleBuyCta;
        if (!label) return;
        // Keep Shopify's native checkout handler and the current form selection.
        if (checkout.textContent !== label) checkout.textContent = label;
        checkout.setAttribute('aria-label', label);
        checkout.classList.add('btn', 'btn--full', 'esmerally-bundle-checkout');
      });
      document.querySelectorAll('.jdgm-carousel-wrapper a.jdgm-carousel-item__product').forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        const label = config.reviewProductLabels[url.pathname];
        if (!label) return;
        const title = link.querySelector('.jdgm-carousel-item__product-title');
        if (title && title.textContent.trim() !== label) title.textContent = label;
        const image = link.querySelector('.jdgm-carousel-item__product-image');
        if (image && image.alt !== label) image.alt = label;
      });
      document.querySelectorAll('.product-section[data-esmerally-price-product] .sls-option-container[data-prepaid="true"]').forEach((option) => {
        const select = option.querySelector('.sls-select');
        const text = select && (select.value === '7813497067' ? config.prepaidSixSummary : select.value === '7813529835' ? config.prepaidTwelveSummary : '');
        let summary = option.querySelector('.esmerally-prepaid-summary');
        if (!text) {
          if (summary) summary.remove();
          return;
        }
        if (!summary) {
          summary = document.createElement('p');
          summary.className = 'esmerally-prepaid-summary';
          summary.setAttribute('aria-live', 'polite');
          option.querySelector('.sls-label-container').append(summary);
        }
        if (summary.textContent !== text) summary.textContent = text;
      });
      const reviewsTitle = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__title');
      if (reviewsTitle && reviewsTitle.textContent !== config.reviewsTitle) reviewsTitle.textContent = config.reviewsTitle;
      const sortLabel = document.querySelector('#judgeme_product_reviews .jdgm-sort-dropdown-label');
      if (sortLabel && sortLabel.textContent !== config.sortBy) sortLabel.textContent = config.sortBy;
      document.querySelectorAll('#judgeme_product_reviews [aria-label], #judgeme_product_reviews img[alt]').forEach((element) => {
        ['aria-label', 'alt'].forEach((attribute) => {
          const current = element.getAttribute(attribute);
          if (!current) return;
          const localized = current
            .replace(/^Average rating is ([\d.]+) stars$/, 'Calificación promedio: $1 de 5 estrellas')
            .replace(/^(\d+)% \((\d+)\) reviews with (\d) star rating$/, '$1% ($2) reseñas de $3 estrellas')
            .replace(/^(\d) star review$/, 'Reseña de $1 estrellas')
            .replace(/^Page (\d+)$/, 'Página $1')
            .replace(/^Verified by Shop$/, 'Verificado por Shop');
          if (localized !== current) element.setAttribute(attribute, localized);
        });
      });
      const countrySelect = document.querySelector('[id$="__17332068787184144230"] .PhoneInputCountrySelect');
      if (countrySelect && typeof Intl.DisplayNames === 'function') {
        countrySelect.setAttribute('aria-label', config.phoneCountry);
        const names = new Intl.DisplayNames(['es'], { type: 'region' });
        Array.from(countrySelect.options).forEach((option) => {
          if (!/^[A-Z]{2}$/.test(option.value)) return;
          const label = option.value === 'ZZ' ? config.international : names.of(option.value);
          if (label && option.textContent !== label) option.textContent = label;
        });
      }
      document.querySelectorAll(productSelector + ' button[aria-controls]').forEach((button) => {
        if (normalize(button.textContent) !== config.nutritionTitle) return;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const inner = panel && panel.querySelector('.collapsible-content__inner');
        if (inner && !inner.hasAttribute('data-esmerally-nutrition') && !inner.querySelector('[data-esmerally-claude-facts]')) {
          inner.innerHTML = config.nutritionHtml;
          inner.setAttribute('data-esmerally-nutrition', '');
        }
      });
    }
    document.querySelectorAll(productSelector).forEach((section) => {
      const prepaid = Boolean(section.querySelector('.sls-option-container.sls-active[data-prepaid="true"]'));
      section.classList.toggle('esmerally-prepaid', prepaid);
      const subscription = Boolean(section.querySelector('.sls-option-container.sls-active[data-selling-plan-group]'));
      section.classList.toggle('esmerally-recurring', subscription);
      const widget = section.querySelector('.sls-purchase-options-container');
      if (widget && spanish) {
        let note = section.querySelector('.esmerally-purchase-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'esmerally-purchase-note';
          note.setAttribute('aria-live', 'polite');
          widget.insertAdjacentElement('afterend', note);
        }
        const active = section.querySelector('.sls-option-container.sls-active');
        const recurring = active && active.hasAttribute('data-selling-plan-group');
        const text = prepaid ? config.prepaidNote : recurring ? config.recurringNote : config.oneTimeNote;
        if (note.textContent !== text) note.textContent = text;
      }
      const label = section.querySelector('.product-block--price > .variant__label');
      const labelText = prepaid ? config.prepaidTotal : config.price;
      if (label && label.textContent.trim() !== labelText) label.textContent = labelText;
      if (spanish) {
        const savings = section.querySelector('[data-save-price]');
        if (savings) {
          const amount = savings.textContent.match(/\$[\d,.]+/);
          if (amount && savings.textContent !== config.save + ' ' + amount[0]) savings.textContent = config.save + ' ' + amount[0];
        }
      }
    });
    const unverifiedPromos = new Set([
      'participa en el sorteo de una cartera de lujo cada mes.',
      'participate in the luxury handbag giveaway every month.',
      'participate in the luxury handbag giveaway every month',
      '¡acceso al sorteo cada mes!',
      'giveaway access every month!'
    ]);
    document.querySelectorAll('.sls-savings-badge, .sls-selling-plan-description-content').forEach((element) => {
      element.toggleAttribute('data-esmerally-unverified-promo', unverifiedPromos.has(normalize(element.textContent).toLowerCase()));
    });
    if (spanish) {
      document.querySelectorAll('.product-section[data-esmerally-price-product]').forEach((section) => {
        syncPaymentSummary(section);
        section.querySelectorAll('[aria-label]').forEach((element) => {
          const label = element.getAttribute('aria-label');
          const dot = label && label.match(/^Page dot (\d+)$/);
          if (dot) element.setAttribute('aria-label', config.galleryImage.replace('{number}', dot[1]));
        });
      });
    }
    // The app may leave its Liquid placeholder in the accessible review label.
    // Do not invent a rating; only repair that unresolved label in Spanish.
    if (spanish) {
      const reviews = document.getElementById('ssw-widget-recommends-html');
      if (reviews && /{{\s*ssw_avg_rate\s*}}/.test(reviews.getAttribute('aria-label') || '')) {
        reviews.setAttribute('aria-label', 'Reseñas del producto');
      }
    }
    syncIndividualCta();
    syncPricePresentation();
    syncIngredientAccess();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked', 'data-prepaid', 'data-selling-plan-group', 'disabled'] });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  };
  // On the Duo landing, unrelated visual class changes do not change purchase copy.
  // Keep all text/child updates and every existing non-class attribute signal.
  const observer = new MutationObserver((records) => {
    if (incrementalTranslations && spanish) records.forEach(record => {
      if (record.type === 'characterData' && record.target.parentElement) pendingTranslations.add(record.target.parentElement);
      if (record.type === 'childList') record.addedNodes.forEach(node => {
        const root = node.nodeType === 1 ? node : node.parentElement;
        if (root) pendingTranslations.add(root);
      });
    });
    if (!location.pathname.endsWith('/pages/womens-pack-vitamins') || records.some(record =>
      record.type !== 'attributes' || record.attributeName !== 'class' ||
      record.target.matches('[data-add-to-cart]') ||
      record.target.closest('.sls-purchase-options-container')
    )) schedule();
  });
  ['sealsubs:subscription_widget_created', 'sealsubs:price_update', 'sealsubs:selling_plan_changed'].forEach((eventName) => document.addEventListener(eventName, schedule));
  document.addEventListener('change', (event) => {
    if (event.target.closest('.product-section[data-esmerally-price-product]')) schedule();
  });
  const openParticipationDetails = (hash) => {
    if (!hash.startsWith('#esmerally-how-') && !hash.startsWith('#esmerally-free-')) return;
    const target = document.getElementById(hash.slice(1));
    const details = target && target.closest('details.esmerally-promo-review__details');
    if (details) details.open = true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.esmerally-promo-review__free-link');
    if (link) openParticipationDetails(link.hash);
  });
  window.addEventListener('hashchange', () => openParticipationDetails(location.hash));
  openParticipationDetails(location.hash);
  sync();
})();
